import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import ThemeEngine from "./theme/ThemeEngine";
import "./styles/index.less";
import { ReduxStoreProvider } from "./redux/provider";
import { BrowserRouter } from "react-router-dom";

import I18nProvider from "./i18n/i18nProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import "moment/locale/it";
import { LocalizationProvider } from "@mui/x-date-pickers";

const root = createRoot(document.querySelector("#root"));

root.render(
  <React.StrictMode>
    <ReduxStoreProvider>
      <I18nProvider>
        <ThemeEngine>
          <LocalizationProvider dateAdapter={AdapterMoment} locale="it">
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </LocalizationProvider>
        </ThemeEngine>
      </I18nProvider>
    </ReduxStoreProvider>
  </React.StrictMode>
);
